export default "__VITE_ASSET__CBPa$Lol__"